interface JSOptions {
  id?: string;
  type?: string;
  async?: boolean;
}
type AllowedDocumentTargets = 'head' | 'body';
export function addJs(jsSrc: string, where: AllowedDocumentTargets, options: JSOptions = { async: false, type: 'text/javascript' }) {
  const scriptEl = document.createElement('script');
  scriptEl.type = options.type || 'text/javascript';
  // scriptEl.async = options.async || false;
  scriptEl.async = false;
  scriptEl.src = jsSrc;
  if (options.id) {
    scriptEl.id = options.id;
  }
  document[where].appendChild(scriptEl);
}
